import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dtransporter',
    templateUrl: './dtransporter.component.html',
    styleUrls: ['./dtransporter.component.scss']
})
export class DtrasnporterComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
